export const isSuperAdmin = (role) => {
    if (['super-admin'].includes(role)) {
        return true;
    }
    return false;
};
export const isAdmin = (role) => {
    if (['admin', 'super-admin'].includes(role)) {
        return true;
    }
    return false;
};
export const isDebtor = (role) => {
    if (['debtor', 'alternative-contact'].includes(role)) {
        return true;
    }
    return false;
};
export const isClient = (role) => {
    if (['client'].includes(role)) {
        return true;
    }
    return false;
};
export const isCaseworker = (role) => {
    if (['caseworker', 'admin', 'super-admin'].includes(role)) {
        return true;
    }
    return false;
};
export const hasScope = (me, tenantId, scope) => {
    const tenantRelation = me.tenants.find((t) => t.id === tenantId);
    return !!tenantRelation?.scopes.includes(scope);
};
//# sourceMappingURL=index.js.map